/**
 * help-topic — 현재 라우트를 도움말 토픽 슬러그로 해석하고 도움말 창을 연다.
 *
 * 슬러그 = 도움말 정적 페이지의 content/<슬러그>.html 파일명(관례).
 * 신규 에이전트는 아래 TOPIC_RULES 에 한 줄 + 도움말 조각 파일만 추가하면 연결된다.
 *
 * 도움말은 idpWeb 정적 자산(public/help/)으로 서빙되며, 공개 URL 계약은
 *   {VITE_HELP_BASE}index.html?topic=<슬러그>&theme=<light|dark>
 * 이다. 베이스를 env 로 주입하므로 향후 별도 컨테이너로 옮겨도 이 코드는 불변이다.
 * index.html을 명시해야 한다 — 확장자 없는 디렉터리 경로(예: /help/)는 Vite dev 서버가
 * public 정적 파일보다 SPA 폴백(메인 앱 index.html)을 먼저 서빙해 React Router 404로 샌다.
 */

const HELP_BASE = ((import.meta.env.VITE_HELP_BASE as string | undefined) ?? '/help/').replace(/\/?$/, '/');

/** 라우트 prefix → 토픽 슬러그. 긴 prefix 가 우선(정렬로 보장). */
const TOPIC_RULES: ReadonlyArray<readonly [string, string]> = [
  ['/agents/photo-organizer', 'photo-organizer'], // 인디포토 · 사진 정리
  ['/agents/scheduler', 'scheduler'], //             인디공사스케줄 · 공사 일정
  ['/agents/work-log', 'work-log'], //               인디공사현황 · 공사 관리
  ['/vendors', 'vendors'], //                        자재 거래처
  ['/partners', 'partners'], //                      시공반장님
  ['/sites', 'sites'], //                            현장 등록
  ['/app', 'overview'], //                           스튜디오 홈 → 빠른 시작 가이드
];

const SORTED_RULES = [...TOPIC_RULES].sort((a, b) => b[0].length - a[0].length);

/** pathname(쿼리 제외)에 대응하는 도움말 토픽. 미매칭이면 'home'. */
export function resolveHelpTopic(pathname: string): string {
  const hit = SORTED_RULES.find(
    ([prefix]) => pathname === prefix || pathname.startsWith(prefix + '/'),
  );
  return hit ? hit[1] : 'home';
}

/**
 * 현재 페이지에 맞는 도움말을 새 창으로 연다.
 * 이름 있는 창('indipia-help')이라 다시 눌러도 같은 창을 재사용해 새 토픽으로 갱신된다.
 */
export function openHelp(pathname: string): void {
  const topic = resolveHelpTopic(pathname);
  const theme = document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
  const url = `${HELP_BASE}index.html?topic=${encodeURIComponent(topic)}&theme=${theme}`;
  window.open(url, 'indipia-help');
}
